import api from "../services/api";


export const getAllCategories = async () => {
  const res = await api.get("/PhotoCategories");
  return res.data;
};

export const getCategoryById = async (id) => {
  const res = await api.get(`${"/PhotoCategories"}/${id}`);
  return res.data;
};

export const createCategory = async (formData) => {
  const res = await api.post("/PhotoCategories", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const updateCategory = async (id, formData) => {
  const res = await api.put(`${"/PhotoCategories"}/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data;
};

export const deleteCategory = async (id) => {
  const res = await api.delete(`${"/PhotoCategories"}/${id}`);
  return res.data;
};
